import { Link } from "react-router";
import { FOOTER_COLUMNS } from "../../lib/nav.js";
import { SITE } from "../../lib/site.js";
import styles from "./Footer.module.css";

const ICONS = {
  LinkedIn:
    "M4.98 3.5C4.98 4.88 3.87 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.2 8h4.6v14H.2V8zm7.6 0h4.4v1.9h.1c.6-1.1 2.1-2.3 4.3-2.3 4.6 0 5.4 3 5.4 6.9V22h-4.6v-6.6c0-1.6 0-3.6-2.2-3.6s-2.5 1.7-2.5 3.5V22H7.8V8z",
  YouTube:
    "M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2 31 31 0 0 0 0 12a31 31 0 0 0 .5 5.8 3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1A31 31 0 0 0 24 12a31 31 0 0 0-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z",
  Facebook:
    "M24 12a12 12 0 1 0-13.9 11.9v-8.4H7.1V12h3V9.4c0-3 1.8-4.7 4.5-4.7 1.3 0 2.7.2 2.7.2v3h-1.5c-1.5 0-2 .9-2 1.9V12h3.4l-.5 3.5h-2.9v8.4A12 12 0 0 0 24 12z",
  Instagram:
    "M12 2.2c3.2 0 3.6 0 4.8.1 3.3.1 4.8 1.7 4.9 4.9.1 1.3.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 3.2-1.7 4.8-4.9 4.9-1.3.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-3.3-.1-4.8-1.7-4.9-4.9C2.2 15.6 2.2 15.2 2.2 12s0-3.6.1-4.8C2.4 3.9 4 2.4 7.2 2.3 8.4 2.2 8.8 2.2 12 2.2zM12 0C8.7 0 8.3 0 7.1.1 2.7.3.3 2.7.1 7.1 0 8.3 0 8.7 0 12s0 3.7.1 4.9c.2 4.4 2.6 6.8 7 7 1.2.1 1.6.1 4.9.1s3.7 0 4.9-.1c4.4-.2 6.8-2.6 7-7 .1-1.2.1-1.6.1-4.9s0-3.7-.1-4.9c-.2-4.4-2.6-6.8-7-7C15.7 0 15.3 0 12 0zm0 5.8a6.2 6.2 0 1 0 0 12.4 6.2 6.2 0 0 0 0-12.4zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.4-11.8a1.4 1.4 0 1 0 0 2.9 1.4 1.4 0 0 0 0-2.9z",
};

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={`section-dark ${styles.footer}`}>
      <div className={`container ${styles.grid}`}>
        <div className={styles.brand}>
          <img
            src="/images/site/logo-white.png"
            alt="RDV Systems"
            width="315"
            height="48"
            loading="lazy"
            className={styles.logo}
          />
          <p className={styles.tagline}>
            {SITE.tagline}. Since {SITE.foundedYear}.
          </p>
          <ul className={styles.social} aria-label="Social media">
            {SITE.social.map((s) => (
              <li key={s.name}>
                <a href={s.href} aria-label={`RDV Systems on ${s.name}`} rel="noopener">
                  <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true">
                    <path fill="currentColor" d={ICONS[s.name]} />
                  </svg>
                </a>
              </li>
            ))}
          </ul>
        </div>
        {FOOTER_COLUMNS.map((col) => (
          <nav key={col.heading} aria-label={col.heading} className={styles.col}>
            <h2 className={styles.heading}>{col.heading}</h2>
            <ul className={styles.links}>
              {col.links.map((l) => (
                <li key={l.href}>
                  <Link to={l.href}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
        <address className={styles.contact}>
          <h2 className={styles.heading}>Contact</h2>
          {SITE.offices.map((o) => (
            <p key={o.label}>
              <strong>{o.label}</strong>
              <br />
              {o.city}
              {o.region ? `, ${o.region}` : ""}, {o.country}
            </p>
          ))}
          <p>
            <a href={SITE.phoneHref}>{SITE.phone}</a>
            <br />
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          </p>
        </address>
      </div>
      <div className={`container ${styles.legal}`}>
        <p>
          © {SITE.foundedYear}–{year} {SITE.name}. All rights reserved.
        </p>
        <ul className={styles.legalLinks}>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/sms-terms">SMS Terms</Link>
          </li>
          <li>
            <Link to="/accessibility">Accessibility</Link>
          </li>
        </ul>
      </div>
    </footer>
  );
}
